export default {
  COMMON_Validation: {
    IC: "Please enter numbers only",
  },
};
